import { createPortal } from 'react-dom';
import { SyncLoader } from 'react-spinners';

import { Container } from './styles';

const Loading = () =>
  createPortal(
    <Container>
      <SyncLoader color="#fff" />
    </Container>,
    document.body
  );

export { Loading };
